import { Directive, HostBinding, Input } from "@angular/core";
import { BooleanAttribute } from "@hex/angular/decorators";

@Directive({ selector: "[modExpandToEdges]" }) export class ExpandModifierDirective {
    @Input() @BooleanAttribute() @HostBinding("class.u-expand-to-edges") public modExpandToEdges: boolean;
}
